<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">REPORTES DE INCIDENCIAS</h5>
      </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-striped table-bordered">
            <thead>
            <tr>
              <th>
              <button
                  class="btn btn-success mx-1"
                  type="button"
                  @click="imprime()">
              <i class="fa fa-file-pdf-o"></i>
              </button>
                <button
                    class="btn btn-success mx-1"
                    type="button"
                    @click="imprimeExel()">
                  <i class="fa fa-file-excel-o"></i>
                </button>

              <button class="btn btn-info m-2" type="button" @click="obtenerReportes()">
                Buscar
                <i class="fa fa-search"></i>
              </button>
              </th>
              <th>
                <select class="custom-select" v-model="selectRobot">
                  <option value="null">SELECCIONAR EQUIPO</option>
                  <option v-for="(t, i) in rbt_robotList" :value="t.nombre" :key="i">{{ t.nombre}}</option>
                </select>
              </th>
            </tr>
            <tr>
              <th colspan="2">
                <b-row>
                  <b-col md="7">
                    <b-form-datepicker
                        id="fecha-inicial"
                        placeholder="Seleccione fecha inicio"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        v-model="fecha_ini"
                    >
                    </b-form-datepicker>
                  </b-col>
                  <!--@input="fechaInicial"-->
                  <b-col md="5">
                    <b-form-timepicker
                        placeholder="Hora"
                        id="ex-disabled-readonly"
                        v-model="hora_ini"
                    >
                    </b-form-timepicker>
                  </b-col>
                </b-row>
              </th>
              <th colspan="2">
                <b-row>
                  <b-col md="8">
                    <b-form-datepicker
                        id="fecha-final"
                        :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                        placeholder="Seleccione fecha final"
                        v-model="fecha_fin"

                        locale="es">
                    </b-form-datepicker>
                    <!--@input="fechaFinal"-->
                  </b-col>
                  <b-col md="4">
                    <b-form-timepicker
                        v-model="hora_fin"
                        id="ex-disabled-readonly"
                        placeholder="Hora"
                    ></b-form-timepicker>
                  </b-col>
                </b-row>
              </th>
            </tr>
            </thead>
            <tbody v-for="(itemes, index) in incidenciasgen" :key="index+20">
            <tr>
              <td colspan="10"><h1>{{itemes.nombre}}</h1></td>
            </tr>
            <tr class="text-center">
              <th><small class="font-weight-bold">EQUIPO</small></th>
              <th><small class="font-weight-bold">FECHA</small></th>
              <th><small class="font-weight-bold">TIPO ERROR</small></th>
              <th><small class="font-weight-bold">REPORTADOS</small></th>
            </tr>
            <tr v-for="(item, index) in itemes.data" :key="index">
              <td><small>{{ item.rbt_equipo }}</small></td>
              <td class="text-center"><small> {{ new moment(item.rbt_fecha).format("DD/MM/YYYY HH:MM:SS") }}</small></td>
              <td class="text-center">{{item.rbt_nombre}}</td>
              <td class="text-center">{{item.rbt_cantidad}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Loading v-show="cargando" />
  </div>
</template>
<script>
import Loading from "../../components/Loading";
export default {
  name: "listaRobot",
  components: {
    Loading,
  },
  data() {
    return {
      seleccionado:'',
      seleccionadoerr1:'',
      seleccionadoerr2:'',
      seleccionadoerr3:'',
      seleccionadoerr4:'',
      seleccionadoerr5:'',
      vueloselec:'',
      fields:[],
      hora_ini:'00:00:00',
      hora_fin:'23:59:59',
      vempresas:[],
      confempresa:[],
      dataenv:{},
      perPage: 3,
      currentPage: 1,

      parametro: '',
      incidenciasgenNew:[],
      incidenciasgen:[],
      incidenciasdet:[],
      observacion : {
        descripcion:'',
        vuelo:'',
        fecha:'28/01/16'
      },
      observaciones:[],
      cargando: false,
      erroresUno:[],
      erroresDos:[],
      erroresTres:[],
      erroresCuatro:[],
      erroresCinco:[],
      fecha_ini:null,
      fecha_fin: null,
      rbt_robotList:[],
      selectRobot:null,
      rbt_id_config_flujo:null,
      rbt_robot:null
    };
  },
  methods: {

    async getNombreEmpresas() {
      try {
        let resultados = await this.axios.get(`/get_Empresa_Vuelo`);
        this.vempresas = resultados.data.contenido;
        //  console.log(this.vempresas);
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getConfigEmpresa() {
      this.cargando = true;
      try {
        this.cargando = false;
        let resultados = await this.axios.get(`/getConfigempresa/${this.seleccionado}`);
        this.confempresa = resultados.data.contenido;
        // console.log(this.confempresa);
        this.cargando = false;
      } catch (error) {
        console.log("catch: ", error);
      }
    },


    async obtenerIncidenciasDetalle(id){
      this.$refs["modalObservacion"].show();
      try {
        let resultados = await this.axios.get(`/incidencias-det/${id}`);
        this.incidenciasdet= resultados.data.contenido;
        //console.log(this.incidenciasdet);
      } catch (error){
        console.log("catch: ", error);
      }
    },
    async obtenerErrores(){
      let resultados = await this.axios.get(`/errores`);
      this.erroresUno= resultados.data.contenido;
    },
    onChangeCentro(){

    },
    hideModalObservado() {
      this.$refs["modalObservacion"].hide();
    },
    seleccionarError(item){
      item.observacion_equipo = "";
    },
    crearReporte(){
      this.$router.push('crearReporte');
    },
    async obtenerReportes(){

      this.rbt_robot= this.selectRobot;
      try {
        let hora_ini_aux=(this.hora_ini == '')?'':' '+this.hora_ini;
        let hora_fin_aux=(this.hora_fin == '')?'':' '+this.hora_fin;
        ///${id_config_flujo}/${fecha_ini}/${fecha_fin}
        let resultados = await this.axios.get(`/reporte-error/${this.rbt_robot}/${this.fecha_ini}${hora_ini_aux}/${this.fecha_fin}${hora_fin_aux}`);
        this.incidenciasgenNew= resultados.data.contenido;
        this.incidenciasgen = this.incidenciasgenNew;
       // console.log(this.incidenciasgen)
      } catch (error){
        console.log("catch: ", error);
      }
    },
    async obtenerRobots(){
      let resultados = await this.axios.get(`/robots`);
      this.rbt_robotList = resultados.data.contenido;
      //console.log(this.rbt_robotList);
    },
    async imprime() {
      //console.log("Hola Mundo")
      let config = { headers: { token: this.token }, responseType: "blob" };
      let hora_ini_aux=(this.hora_ini == '')?'':' '+this.hora_ini;
      let hora_fin_aux=(this.hora_fin == '')?'':' '+this.hora_fin;
      try {
        let resultados = await this.axios.get(`/reporte-error-pdf/${this.rbt_robot}/${this.fecha_ini}${hora_ini_aux}/${this.fecha_fin}${hora_fin_aux}`,config);
        // console.log(resultados)
        await this.crearDescarga(resultados, "reporte.pdf");
      } catch (error) {
        console.log(error);
      }
    },
    async imprimeExel() {
      let config = { headers: { token: this.token }, responseType: "blob" };
      let hora_ini_aux=(this.hora_ini == '')?'':' '+this.hora_ini;
      let hora_fin_aux=(this.hora_fin == '')?'':' '+this.hora_fin;
      try {
        let resultados = await this.axios.get(`/reporte-errorxls/${this.rbt_robot}/${this.fecha_ini}${hora_ini_aux}/${this.fecha_fin}${hora_fin_aux}`,config);
        // console.log(resultados)
        await this.crearDescarga(resultados, 'reporte.xlsx');
      } catch (error) {
        console.log(error);
      }
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(
          new Blob([response.data], { type: "blob" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
  },
  created() {
    this.obtenerErrores(),
        this.getNombreEmpresas(),
        this.obtenerReportes(),
        this.obtenerRobots()

  },

};
</script>
